import { useDeferredValue } from 'react';
import { isSameDay } from 'date-fns';
import { create } from 'zustand';

import type { ApiHistoryLogType } from '@izimi/api';

import { FIRST_OF_JANUARY_2019 } from '../documents';

type Filters = {
  afterDate: Date;
  beforeDate: Date;
  types: Array<Array<ApiHistoryLogType>>;
};

type HistoryLogFiltersStore = {
  filters: Filters;
  setFilters: (filters: Filters) => void;
  resetFilters: () => void;
  searchValue: string;
  setSearchValue: (searchValue: string) => void;
  hasActiveFilters: () => boolean;
};

const initialState: HistoryLogFiltersStore = {
  filters: {
    afterDate: FIRST_OF_JANUARY_2019,
    beforeDate: new Date(),
    types: [],
  },
  setFilters: () => {},
  resetFilters: () => {},
  searchValue: '',
  setSearchValue: () => {},
  hasActiveFilters: () => false,
};

export const useHistoryLogFiltersStore = create<HistoryLogFiltersStore>()((set, get) => ({
  ...initialState,
  setFilters: (filters: Filters) => {
    set({ ...get(), filters });
  },
  resetFilters: () => {
    set({ ...get(), filters: initialState.filters });
  },
  setSearchValue: (searchValue: string) => {
    set({ ...get(), searchValue });
  },
  hasActiveFilters: () => {
    const { afterDate, beforeDate, types } = get().filters;
    return (
      !isSameDay(afterDate, FIRST_OF_JANUARY_2019) ||
      !isSameDay(beforeDate, new Date()) ||
      types.length > 0
    );
  },
}));

export const useHistoryLogFiltersSearchValue = () => {
  const { searchValue } = useHistoryLogFiltersStore();
  const debouncedValue = useDeferredValue(searchValue);

  return debouncedValue;
};
